import { FloorPilotMarkVector } from "@/components/brand/floorpilot-mark-vector"
import { FloorPilotWordmarkVector } from "@/components/brand/floorpilot-wordmark-vector"
import { BRAND_NAME } from "@/lib/brand"
import { cn } from "@/lib/utils"

/** Which brand lockup the logo uses (navbar wordmark, compact mark, or auth panel). */
export type FloorPilotLogoVariant = "navbar-wordmark" | "navbar-mark" | "auth-wordmark"

type FloorPilotLogoProps = {
  variant: FloorPilotLogoVariant
  className?: string
}

/**
 * Single-color vector logos colored via `currentColor` — theme is handled by the surrounding
 * text color (no raster files, no `dark:invert` hacks). viewBoxes are tight so there is no
 * phantom padding around the artwork.
 */
export function FloorPilotLogo({ variant, className }: FloorPilotLogoProps) {
  if (variant === "navbar-wordmark") {
    return (
      <FloorPilotWordmarkVector
        role="img"
        aria-label={BRAND_NAME}
        className={cn("text-foreground hidden h-7 w-auto md:block", className)}
      />
    )
  }

  if (variant === "navbar-mark") {
    return (
      <FloorPilotMarkVector
        role="img"
        aria-label={BRAND_NAME}
        className={cn("text-foreground block size-7 md:hidden", className)}
      />
    )
  }

  // auth-wordmark: rendered white on the dark auth panel.
  return (
    <FloorPilotWordmarkVector
      role="img"
      aria-label={BRAND_NAME}
      className={cn("h-auto w-full max-w-[16rem] text-white sm:max-w-[18rem] lg:max-w-[20rem]", className)}
    />
  )
}
